import { Pipe, PipeTransform } from '@angular/core';
import { IProperty } from '../components/form/IProperty.interface';

@Pipe({
    name: 'keyFor',
    pure: false,
})
export class KeyForPropertyPipe implements PipeTransform {
    transform(property: IProperty, lang?: string): string {
        if (property.type === 'translatable-text') {
            return property.property + '-' + property.type + '-' + lang;
        } else if (property.type === 'translatable-markup') {
            return property.property + '-' + lang;
        } else {
            return property.property;
        }
    }
}
